import React, { useState } from "react";

export default ({ attachment, clearAttachment }) => {
  const [attachmentTypeName] = useState(attachment.name.split("."));
  const type = ((type) => {
    if (type.includes("image")) {
      return "image";
    }

    if (type.includes("video")) {
      return "video";
    }

    if (type.includes("audio")) {
      return "audio";
    }

    return "";
  })(attachment.type);
  return (
    <>
      <div
        className="element"
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          justifyContent: "center",
          padding: "10px",
          color: "orange",
        }}
      >
        <span className="name" style={{ fontSize: "25px" }}>
          Media Added
        </span>
        <span className="name">
          {type === "image"
            ? "Photo.png"
            : type === "audio"
            ? "Audio.mpg"
            : type === "video"
            ? `Video.${attachmentTypeName[1]}`
            : "Media"}
          <i
            className="fa fa-close"
            style={{
              margin: "0px 9px",
              cursor: "pointer",
              fontSize: "20px",
              color: "black",
            }}
            onClick={clearAttachment}
          ></i>
        </span>
      </div>
    </>
  );
};
